module.exports = __webpack_public_path__ + "img/control-p-sinop.72be412d.png";